export default __webpack_public_path__ + "d2acf12bbab3a3a8d927e18f83bd355b.png";